module.exports = __webpack_public_path__ + "static/media/mapa-a3.64fdf272.png";